import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopInnerBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,

} from "../../components/common/UiPageElements"
import OrderContent from "./Views/OrderContent"
import OrderPointSection from "./Views/OrderPointSection"
import {UiOrderDetails,
        UiOrderDetailsColWr,
        UiOrderDetailsColName,
        UiOrderDetailsHr,
        UiOrderDetailsColStatus,
        UiOrderDetailsColValidUnit,
        UiOrderDetailsColLabel} from "../../components/common/UiProductElements"
import { WhatsIncluded } from "./Views/WhatsIncluded"
import OrderTopDetails from "./Views/OrderTopDetails"
import Footer from "../../components/footer/Footer"

export default function OrderDetails(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="Order Details"
                    description="Product Description Text" />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Broswe All Products"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12">
                            <OrderTopDetails/>
                        </UiCol>
                        <UiCol lg="4" xl="4">
                            <OrderPointSection/>
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <OrderContent/>
                            <UiSingleRow className="mt-4">
                                <UiCol lg="12">
                                 <WhatsIncluded/>
                                </UiCol>
                            </UiSingleRow>
    
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>
        </>
    )
}
